import React from "react";

import { CollapseSection, History } from "components";
import {
	buyRatesAreApplicableRender,
	createScheduleARender,
	mainScheduleARender,
	scheduleAByNameRender,
	scheduleAFeeRender,
} from "components/pages/historyTab/actionRenderers";
import { mainHistoryScheduleANames } from "mappers";
import { useGetScheduleAHistoryQuery } from "queries";

import styles from "../scheduleAView.module.scss";

const GET_SCHEDULE_A_HISTORY_KEY = "getApplicationHistory";

const HistoryScheduleA = ({ scheduleId }: { scheduleId: string }) => {
	const getRendererByKey = key => {
		if (key === mainHistoryScheduleANames.NAME) {
			return mainScheduleARender("Schedule A Name");
		} else if (key === mainHistoryScheduleANames.PROCESSOR_ID) {
			return scheduleAByNameRender("Processor");
		} else if (key === mainHistoryScheduleANames.PARENT_ID) {
			return scheduleAByNameRender("Copy from Agent Office Schedule A`s");
		} else if (key === mainHistoryScheduleANames.STATUS) {
			return mainScheduleARender("Schedule A Status");
		} else if (key === mainHistoryScheduleANames.ARE_FEES_NOT_APPLICABLE) {
			return buyRatesAreApplicableRender;
		} else if (key.startsWith("fees")) {
			const keys = key?.split(".");
			const propertyKey = keys[keys.length - 1];
			const correctFeesData = parseInt(propertyKey);

			return isNaN(correctFeesData) && scheduleAFeeRender;
		} else if (key === mainHistoryScheduleANames.SCHEDULE_A) {
			return createScheduleARender;
		} else return;
	};

	return (
		<CollapseSection
			header="History"
			className={styles.collapseWrapper}
			classNameHeader={styles.collapseHeader}
			classNameBody={styles.collapseBody}
		>
			<History
				id={scheduleId}
				classNameHeader={styles.tableHeader}
				historyKey={GET_SCHEDULE_A_HISTORY_KEY}
				getRendererByKey={getRendererByKey}
				useHistoryListQuery={useGetScheduleAHistoryQuery}
			/>
		</CollapseSection>
	);
};

export default HistoryScheduleA;
